import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdLockClock } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Form from "shared/components/Form";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";
import ActionButtons from "../../../../../../Projects/Detail/Templates/Manual/Lafourgale/Components/ActionButtons";

const View = ({ subscription, totalPrice, translation }) => {
  const navigate = useNavigate();
  const projectNumber = get(subscription, "id", "");

  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const TRANSLATION = t("DETAIL.TEMPLATES.LAFOURGALE.SIGNATURE_WAITING", {
    returnObjects: true,
  });

  return (
    <div className="contact-form lf-subscription-done" key="form_area">
      <div className="contact-form__content">
        <div className="lf-subscription-done__wrapper mb-32">
          <Form>
            <div className="lf-subscription-done__header">
              <div className="lf-subscription-done__icon-wrapper">
                <MdLockClock size={48} color="#52c41a" />
              </div>
              <h1 className="lf-subscription-done__title">
                {TRANSLATION.TITLE}
              </h1>
              <p className="lf-subscription-done__description">
                {TRANSLATION.DESCRIPTION.replace(
                  "{{projectNumber}}",
                  projectNumber,
                )}
              </p>
            </div>
          </Form>
        </div>
        <ActionButtons
          onSubmit={() => navigate(SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path)}
          translation={{ NEXT: TRANSLATION.BACK_TO_DASHBOARD }}
        />
      </div>
    </div>
  );
};

export default View;
